import { useMemo, useRef, useState } from 'react';
import { Swiper } from 'swiper/types';
import Image from 'components/gruenland/atoms/image';
import Slider from 'components/gruenland/atoms/slider/Slider';
import { Ico360 } from 'components/gruenland/icons/360';
import { sortProductImages } from 'lib/wardaImages';
import Modal360 from './Modal360';

interface GalleryProps {
  images: Array<string>;
  image360?: string;
}

const Gallery: React.FC<GalleryProps> = ({ images, image360 }) => {
  const swiperRef = useRef<Swiper>(null);

  const [showModal, setShowModal] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const sortedImages = useMemo(() => sortProductImages(images), [images]);

  return (
    <div className="gap-y-8">
      {/* MOBILE GALLERY */}
      <div className="relative mx-5 h-[300px] lg:hidden">
        <div className={isLoading ? 'block' : 'hidden'}>
          <Image src={sortedImages[0]} loading="eager" suffix="large" style={{ objectFit: 'contain' }} fill />
        </div>
        <div className={isLoading ? 'hidden' : 'block'}>
          <Slider
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            arrows={false}
            dots={images.length > 1}
            slidesPerView={1}
            loop
            onInit={() => setIsLoading(false)}
          >
            {sortedImages.map((image, index) => (
              <div key={image} className="relative h-[300px] w-full">
                <Image src={image} loading={index === 0 ? 'eager' : 'lazy'} style={{ objectFit: 'contain' }} fill />
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* DESKTOP GALLERY */}
      <div className="hidden flex-col gap-5 lg:flex">
        {sortedImages.map((image, index) => (
          <div key={image} className="flex w-full justify-center bg-gray-50">
            {image360 && index === 0 ? (
              <div className="relative">
                <Image src={image} className="mix-blend-darken" width={900} />
                <button
                  className="absolute bottom-10 right-10 flex size-12 items-center justify-center rounded-full bg-white"
                  onClick={() => setShowModal(true)}
                >
                  <Ico360 />
                </button>
              </div>
            ) : (
              <Image src={image} className="mix-blend-darken" width={900} />
            )}
          </div>
        ))}
        {showModal && image360 && <Modal360 image360={image360} onClose={() => setShowModal(false)} />}
      </div>
    </div>
  );
};

export default Gallery;
